/* A KuduTractID is "client.project.section.tract-horizon", and each horizon is its own map feature
 * carrying the tract's polygon. Tract-level logic (e.g. counting the tracts under the mouse) keys
 * on the part before the last dash, so a tract's horizons count once. */

/** "1516.1.3.5-2" -> "1516.1.3.5". An id without a horizon suffix is returned as is. */
export const tractKeyOf = (kuduTractId: string | null | undefined): string => {
    const id = String(kuduTractId ?? '').trim();
    const dash = id.lastIndexOf('-');
    return dash > 0 ? id.slice(0, dash) : id;
};

/** The first item for each tract, in order. Items without a Kudu ID can't be grouped and are kept. */
export const firstPerTract = <T>(items: T[], kuduIdOf: (item: T) => string | null | undefined): T[] => {
    const seen = new Set<string>();
    return items.filter((item) => {
        const key = tractKeyOf(kuduIdOf(item));
        if (!key) {
            return true;
        }
        if (seen.has(key)) {
            return false;
        }
        seen.add(key);
        return true;
    });
};



// WEBPACK FOOTER //
// ./src/components/project/sections/GISComponents/tractIdentity.ts